/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbSyncProgressResponse {
    getFixupPrototypeFunction() { return ServiceNowCmdbSyncProgressResponse.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbSyncProgressResponse>): ServiceNowCmdbSyncProgressResponse {
        let obj = Object.assign(new ServiceNowCmdbSyncProgressResponse(), model);
        ServiceNowCmdbSyncProgressResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbSyncProgressResponse>): ServiceNowCmdbSyncProgressResponse {
        if (!model) return null;
        return ServiceNowCmdbSyncProgressResponse.newInstance(<ServiceNowCmdbSyncProgressResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbSyncProgressResponse) {
        if (!obj) return;

        models.ServiceNowCmdbSyncProgressResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbSyncProgressResponse): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbSyncProgressResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.progress) {
            models.ServiceNowCmdbSyncProgress.fixupPrototype(this.progress);
        }
    }

    /**
     * ServiceNow Cmdb sync status
     */
    status: models.BackgroundJobStatus;

    /**
     * Progress of the ServiceNow Cmdb sync
     */
    progress: models.ServiceNowCmdbSyncProgress;

}
